exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".PageSettingsEditor {\n  background-color: white;\n  width: calc(100% - 20px);\n  margin: 30px 10px 40px;\n  padding: 30px 10px 30px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/RLX/Views/Dashboard/Panes/PageEditor/PageSettings/PageSettingsEditor.scss
// module id = 412
// module chunks = 0